import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css"; // Required for styling
import $ from "jquery"; // Required for jQuery to work with DataTable
import "datatables.net"; // Import DataTable jQuery plugin

function BusinessList() {
  const navigate = useNavigate();
  const location = useLocation();
   const [dataTable, setDataTable] = useState(null); // For storing DataTable instance
  const [requestData, setRequestData] = useState([]); // Initialize as an empty array
  const dataTableRef = useRef(null); // Reference to the DataTable element

  // Extract query parameter 'id' from the URL
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
   // Initialize DataTable once
   if (!dataTable) {
    const table = $("#business").DataTable({
      serverSide: true,
      processing: true,
      ordering: true,  // Enable ordering
      order: [[4, 'desc']],      // Start with no initial order
      ajax: function (data, callback, settings) {
        const page = settings._iDisplayStart / settings._iDisplayLength + 1;
        const search = data.search.value || "";
        const length = data.length || "";
        
        // Default sorting
        let orderColumn = "createdAt";
        let orderDir = "desc";
        
        // Only override defaults if valid order data exists
        try {
          if (data.order && 
              data.order[0] && 
              settings.aoColumns && 
              settings.aoColumns[data.order[0].column]) {
            const column = settings.aoColumns[data.order[0].column];
            if (column.name) {
              orderColumn = column.name;
              orderDir = data.order[0].dir;
            }
          }
        } catch (error) {
          console.log("Sorting error handled:", error);
        }

        console.log("orderColumn", orderColumn);
        console.log("orderDir", orderDir);
        
        fetchData(page, search, length, orderColumn, orderDir).then((response) => {
          callback({
            draw: response.draw,
            recordsTotal: response.recordsTotal,
            recordsFiltered: response.recordsFiltered,
            data: response.data,
          });
        });
      },
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 },
          {
            data: 'user',
            name: 'user.mobile',
            render: (data) => (data && data[0] && data[0].mobile) || 'N/A' // Safely check if user exists and has a mobile
          },
          { 
            data: 'name', 
            name: 'name',
            render: (data) => data || 'N/A' // Business name from business object
          },
          { 
            data: 'business_logo', 
            name: 'business_logo',
            render: (data) => data ? `<img src="${data}" alt="Business Logo" style="max-width: 100px; max-height: 50px;" />` : 'N/A' // Business logo
          },
          { 
            data: 'createdAt', 
            name: 'createdAt',
            orderable: true,
            render: (data) => new Date(data).toLocaleString() || 'N/A' 
          },
          {
            data: null,
            render: (data) => {
              // Safely access businessId using optional chaining
              const businessId = data?._id;

              // Check if businessId is available
              if (businessId) {
                return `
                  <div align="center">
                    <a href="/geotags?id=${businessId}" class="crsr_pntr">
                      <i class="fa-solid fa-eye mr-2"></i>
                    </a>
                  </div>
                `;
              } else {
                return ''; // If no businessId, return 'N/A'
              }
            }
          }
        ],
        pageLength: 10,
        lengthMenu: [10, 25, 50, 75, 100],
        responsive: true,
        searching: true,
        paging: true,
        drawCallback: function (settings) {
          // Set default sort only on first draw
          if (settings._iDisplayStart === 0 && !this.api().order().length) {
            this.api().order([4, 'desc']).draw();
          }
        },
      });

      setDataTable(table); // Store DataTable instance
    }

    // Cleanup DataTable when the component is unmounted
    return () => {
      if (dataTable) {
        dataTable.clear().destroy();
      }
    };
  }, [dataTable]); // Only initialize once

  const fetchData = async (page, search = "", length= "",orderColumn="",orderDir="") => {
    try {
      const limit = length || 10;
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "businessList",
          module: "user",
          userId: userId ? userId : "",
          index: page,
          limit: limit,
          search: search, // Send search term if available
          orderColumn:orderColumn,
          orderDir:orderDir
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        const users = data.result.businesses;
        const totalBusinesses = data.result.pagination.totalBusinesses; // Get total users count

        return {
          draw: data.draw, // Draw counter for DataTable
          recordsTotal: totalBusinesses, // Total records (from API)
          recordsFiltered: totalBusinesses, // Filtered records (can be same if no filters)
          data: users, // Data for the current page
        };
      } else {
        console.error("Failed to fetch users:", data);
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return {
        draw: 0,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
      };
    }
  };



  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Businesses</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                
                  <div className="table-responsive">
                    <table
                      ref={dataTableRef}
                      id="business"
                      className="table table-striped table-bordered txt_lft"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Phone</th>
                          <th>Business Name</th>
                          <th>Logo</th> {/* New column for Business Logo */}
                          <th>CreatedAt</th> {/* New column for GeoTags View */}
                          <th>GeoTags</th> {/* New column for GeoTags View */}
                        </tr>
                      </thead>
                      <tbody>
                        {/* Data rows will be populated by DataTable */}
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BusinessList;
